export default __webpack_public_path__ + "assets/445ff2f4389804652ad7937c73ea8f61.gif";